<template>
    <div class="loading-wrapper">
        <LoadingSpinner />
        
        <!--
            <h5>Loading...</h5>
            <hr>
        Event
        Meeting slots
        Tracks
        Appointments
        Custom fields
        Attendees
        Organisations
        Attendee(me)
        Meetings
        Messages
        -->
        <h5>Authenticated
            <ProgressBar :percent="loggedIn ? 100 : 0" />    
        </h5>

         <h5 v-if="percentMe >= 0">My data
            <ProgressBar :percent="percentMe" />
        </h5>
        <h5 v-if="percentAppointments >= 0">Sessions
            <ProgressBar :percent="percentAppointments" />
        </h5>
        <h5 v-if="percentMeetings >= 0">Meetings
            <ProgressBar :percent="percentMeetings" />
        </h5>

        <div v-if="percentRoot > 100" 
            class="alert">
            <b>Sorry!</b> Please reload this page.
        </div>
        <!--
        <h5>Meeting slots
            <ProgressBar :percent="percentSlots" />
        </h5>
        <h5>Tracks
            <ProgressBar :percent="percentTracks" />
        </h5>
        <h5>Messages
            <ProgressBar :percent="percentMessages" />
        </h5>
        <h5>Attendees
            <ProgressBar :percent="percentAttendees" />
        </h5>
        <h5>Organisations
            <ProgressBar :percent="percentOrganisations" />
        </h5>
        -->
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import LoadingSpinner from "./LoadingSpinner";
    import ProgressBar from "./ProgressBar";

    export default {
        name: "Loading",
        components: {
            LoadingSpinner,
            ProgressBar
        },
        computed: {
            percentRoot() {
                return this.$store.state.loading;
            },
            percentSlots() {
                return this.$store.state.slots.loading;
            },
            percentMe() {
                return this.$store.state.me.loading;
            },
            percentAppointments() {
                return this.$store.state.appointments.loading;
            },
            percentMeetings() {
                return this.$store.state.meetings.loading;
            },
            /*
            percentTracks() {
                return this.$store.state.tracks.loading;
            },
            percentMessages() {
                return this.$store.state.messages.loading;
            },
            percentMeetings() {
                return this.$store.state.meetings.loading;
            },
            percentAttendees() {
                return this.$store.state.attendees.loading;
            },
            percentOrganisations() {
                return this.$store.state.organisations.loading;
            },
            */
            ...mapGetters({
                loggedIn: 'loggedIn',
            }),
        },
    }
</script>

<style>
    .loading-wrapper {
        background-color: #f6f6f6;
        border-radius: 5px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 0 auto;
        padding: 10px;
        width: 300px;
    }
    .loading-wrapper h3 {
        text-align: center;
    }
    .loading-wrapper .progress {
        margin-bottom: 0;
    }
</style>